interface AccountsPerIpInterface {
    accountCount: number;
    occurences: number;
}

class AccountsPerIp implements AccountsPerIpInterface {
    accountCount: number;
    occurences: number;
}

export {
    AccountsPerIpInterface,
    AccountsPerIp
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/bases/proxy/statistics/receivers/api.models.ts